var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLittleRisk = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#85ca0a",
  stroke: "#282828",
  strokeWidth: 5,
  "data-name": "Rectangle 3"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M2.5 2.5h35v35h-35z"
}))));
export default SvgLittleRisk;